import { FormEditorTypes } from "@/components/forms/form-editor.config.ts";
import { FormEditor } from "@/components/forms/FormEditor.tsx";
import { SurveyTemplateEditSidebar } from "@/pages/talent/surveys/templates/edit/components/SurveyTemplateEditSidebar.tsx";
import {
  TemplateEditPageProps,
  useTemplateEditPage,
} from "@/pages/talent/surveys/templates/edit/pages/survey-template-edit-pages.tsx";
import { SurveyTemplateTitleSlot } from "@/pages/talent/surveys/templates/edit/pages/SurveyTemplateTitleSlot.tsx";
import { SurveyTemplateEditPageStep } from "@/pages/talent/surveys/templates/edit/survey-template-edit.ts";
import { Button, FullScreenPage, Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const SurveyTemplateEditQuestionsPage = ({ template }: TemplateEditPageProps) => {
  const { t } = useTranslation();
  const { exit, confirmExit, navigateToStep } = useTemplateEditPage();

  return (
    <FullScreenPage
      backSlot={
        <Button variant={"secondary"} size={"lg"} onClick={confirmExit}>
          {t("common:exit")}
        </Button>
      }
      titleSlot={
        <SurveyTemplateTitleSlot step={SurveyTemplateEditPageStep.questions} template={template} />
      }
      isCenterVertical={false}
      contentSize={"md"}
      sidebarSlot={
        <SurveyTemplateEditSidebar
          step={SurveyTemplateEditPageStep.questions}
          template={template}
        />
      }
      actionsSlot={
        <>
          <Button
            variant={"secondary"}
            size={"lg"}
            onClick={() => {
              navigateToStep(template.id, SurveyTemplateEditPageStep.details);
            }}
          >
            {t("common:back")}
          </Button>
          <Button size={"lg"} onClick={exit}>
            {t("common:save")}
          </Button>
        </>
      }
    >
      <Stack gap={"lg"}>
        <FormEditor type={FormEditorTypes.surveyTemplate} id={template.id} />
      </Stack>
    </FullScreenPage>
  );
};
